import { DataFichaRegistro, Municipio } from './../../../../../../models/fichaRegistro.model';
import { Component, OnInit } from '@angular/core';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { map, Observable, Subscription } from 'rxjs';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { InfoUbicacion } from './models/ubicacion.model';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { UtilsService } from 'app/modules/utils-service';
import { ActivatedRoute } from '@angular/router';
import { Tipologia } from 'app/models/tipologias.model';
import { environment as env } from 'environments/environments';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'ubicacion',
    templateUrl: 'ubicacion.component.html',
    imports:[
        CommonModule, MatButtonModule, FormsModule, MatFormFieldModule, MatSelectModule, MatIconModule
    ]
})

export class UbicacionComponent implements OnInit {
    tipology_departamentos:number = env.TIPOLOGIA_ID_DEPARTAMENTOS
    infoUbicacion: InfoUbicacion;
    uu_id:string

    informacionFichaRegistro$:Observable<DataFichaRegistro>
    departamentos:Tipologia[]=[]
    municipios:Tipologia[]=[]

    mapaUrl: SafeResourceUrl;

    private subscription: Subscription;
    
    constructor(
        private detalleBienesService:DetalleBienCulturalService,
        private utilsService: UtilsService,
        private route:ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {
        this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
        this.informacionFichaRegistro$ = this.detalleBienesService.fichaRegisto$;
    }

    ngOnInit() {
        this.getDepartamento().then(() => {
        this.subscription = this.detalleBienesService.fichaRegisto$.pipe(
            map(fichas => {
                if (fichas && fichas.bienCultural) {
                return new InfoUbicacion(fichas.bienCultural);
                }
                return null;
            })
        ).subscribe(info => {
        this.infoUbicacion = info;

        this.actualizarMapa();

        // Asigna el departamento completo del listado
        const depMatch = this.departamentos.find(d => d.tipologiaId === this.infoUbicacion.departamento?.tipologiaId);
            if (depMatch) {
                this.infoUbicacion.departamento = depMatch;
                this.getMunicipios(depMatch).then(() => {
                // con los municipios cargados, se mapea el municipio
                const munMatch = this.municipios.find(m => m.tipologiaId === this.infoUbicacion.municipio?.tipologiaId);
                if (munMatch) {
                    this.infoUbicacion.municipio = munMatch;
                }
                });
            }
            });
        });
            
    }

    actualizarInformacion(){
        this.detalleBienesService.actualizarUbicación(this.infoUbicacion, this.uu_id)
        .then(response=>{
            this.utilsService.openSuccessSnakBar('Se ha actualizado la información correctamente.')
            this.detalleBienesService.getBitacoraBienes(this.uu_id)
            this.detalleBienesService.getFichaRegistro(this.uu_id)
        })
    }

    getDepartamento(): Promise<void> {
        return this.detalleBienesService.getTipologias(this.tipology_departamentos)
            .then((response: Tipologia[]) => {
            this.departamentos = response;
            });
    }

    getMunicipios(departamento: Tipologia): Promise<void> {
        return this.detalleBienesService.getTipologias(departamento.tipologiaId)
            .then((response: Tipologia[]) => {
            this.municipios = response;
            });
    }


    obtenerUbicacion() {
        if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                this.infoUbicacion.latitud= lat.toString()
                this.infoUbicacion.longitud = lng.toString()

                this.actualizarMapa()
            },
            (error) => {
            console.error('Error obteniendo ubicación:', error);
            }
        );
        }
    }

    actualizarMapa(): void {
        const lat = this.infoUbicacion?.latitud;
        const lng = this.infoUbicacion?.longitud;

        // Verificar que ambos valores existen y son números válidos
        if (lat && lng) {
            const url = `https://www.google.com/maps?q=${lat},${lng}&hl=es&z=15&output=embed`;
            this.mapaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
            const url = `https://www.google.com/maps?q=14.6349,-90.5069&hl=es&z=12&output=embed`;
            this.mapaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }


}